import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UserService } from './services/user.service';
import { CondominiumService } from './services/condominium.service';
import { SilentAuthService } from './services/silent-auth.service';
import { AuthService } from './services/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.sass'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'green-village-front';
  showCondominiumLinks = false;
  isOwner = false;
  condominiumId: number | null = null;
  isHomeRoute = false;
  showSidenav = true;
  private tokenUpdatedSubscription?: Subscription;

  @ViewChild('sidenav') sidenav?: MatSidenav;

  constructor(
    private userService: UserService,
    private condominiumService: CondominiumService,
    private router: Router,
    private route: ActivatedRoute,
    private silentAuthService: SilentAuthService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.updateRouteState(this.router.url);
    this.updateEmailConfirmedUi();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.updateRouteState(event.url);
      this.updateSidenavLinks();
      this.updateEmailConfirmedUi();
    });

    this.tokenUpdatedSubscription = this.authService.tokenUpdated$.subscribe(() => {
      this.updateEmailConfirmedUi();
    });

    this.route.firstChild?.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.condominiumId = +id;
      }
    });

    this.silentAuthService.setupAutoRenewal();
  }

  ngOnDestroy(): void {
    this.tokenUpdatedSubscription?.unsubscribe();
  }

  onMenuClick(): void {
    this.sidenav?.toggle();
  }

  private updateRouteState(url: string): void {
    const path = (url || '/').split('?')[0].split('#')[0];
    this.isHomeRoute = path === '/' || path === '';
  }

  private updateEmailConfirmedUi(): void {
    this.showSidenav = this.authService.getEmailConfirmedClaim() !== false;
  }

  private async updateSidenavLinks(): Promise<void> {
    // Check if current route is in a condominium context
    const url = this.router.url;
    this.showCondominiumLinks = url.includes('/condominium/');
    this.condominiumId = this.route.firstChild?.snapshot.params['id'];
    
    if (this.showCondominiumLinks && this.condominiumId) {
      // Check if user is owner
      this.isOwner = await this.condominiumService.isCurrentUserOwnerOfCondominium(this.condominiumId);
    }
  }
}
